import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChatBotComponent } from 'app/layout/components/chat-bot/chat-bot.component';

@NgModule({
    imports: [
        MatTooltipModule,
        ChatBotComponent
    ],
    exports: [
        ChatBotComponent
    ]
})

export class ChatBotModule { }
